<template>
  <div class="sitebuilder-element-container is-receiver"
       element="BoxComponent"
       :data-hide-desktop="!this.internal_config.showDesktop" :data-hide-mobile="!this.internal_config.showMobile"
       :id="id"
       :config-properties="JSON.stringify(internal_config)"
       v-on:click="focusElement($event)"
       ref="elem"
       :key="componentKey"
       :keyChange="keyChange"
       @contextmenu.prevent="handler($event)"
       :style="style()">
    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)"
                             v-bind:h="parseInt(internal_config.height)"
                             @resizing="onResize" ref="draggableResizable"
                             :draggable="false" :enable-native-drag="true">
      <sync-drag :target="this" />

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-BoxComponent'>
        <img  src="static/images/icons/pin.svg"
              v-tooltip="{content:$t('ct-pin'),  class: 'tooltip-custom'}"
              class="svg-icon normal-action hide-resource-on-mobile"
              @click="PinElement"/>
      </options-element-bar>

      <div v-bind:style="{
       'border-radius': radius,
        background: background(),
        height : height(),
        minHeight : minHeight(),
        width : width(),
        border : border(),
        'box-shadow': boxShadow,
       }"
           :keyChange="keyChange"
           ref="boxElem"
           class="sitebuilder-element-receiver">

        <!-- hotmart help -->
        <div v-if="showHotMart()" class="hotmart-preview" style="display: flex; flex-wrap: wrap; justify-content: center; align-items: center; height: 100%; flex-direction: column;">
          <img src="https://logodownload.org/wp-content/uploads/2018/03/hotmart-logo.png" width="200" alt=""/>
          <p class="clean-text-css" style="color: white" v-if="internal_config.hotmart.key === ''"> {{ $t('ct-hotmart-key-empty') }} </p>
          <p class="clean-text-css" v-else> {{ $t('ct-hotmart-enabled-on-box') }} </p>
        </div>


         <!-- eduzz help -->
        <div v-if="showEduzz()" class="hotmart-preview" style="display: flex; flex-wrap: wrap; justify-content: center; align-items: center; height: 100%; flex-direction: column;">
          <img src="https://cdn.imp-multimedia.com/3w2pmfvviawwosoc4.png" width="200" alt=""/>
          <p class="clean-text-css" style="color: black" v-if="internal_config.eduzz.code === ''"> {{ $t('ct-eduzz-code-empty') }} </p>

        </div>

        <component v-for="(element,index) in elements" :is="element.name" :config="element.config" :key="index"
                   :id="element.id" :height_start="index" :preview="preview" :childs="element.childs" :device="device"
                   @setCallbackChangeDevice="setCallbackChangeDevice"></component>
      </div>
    </vue-draggable-resizable>
  </div>
</template>
<script>

  import Model from './Model';
  import OptionsElementBar from '../OptionsElementBar';

  export default {
    name: 'BoxComponent',
    components: {
      OptionsElementBar,
      Model
    },
    props: ['config', 'childs', 'height_start', 'device', 'id', 'preview'],
    data() {
      return Model.data();
    },
    created() {
      this.componentKey = '1';
    },
    computed: {

      boxShadow() {
        return this.internal_config.boxShadow;
      },
      radius() {
        return this.internal_config.borderRadius;
      }
      // bg-color bg-image position/bg-size bg-repeat bg-origin

    },
    methods: {
      showHotMart() {

        if(typeof this.internal_config.hotmart !== 'undefined' && this.internal_config.hotmart.enabled){
          return true;
        } else{
          return false;
        }

      },

      showEduzz() {

        if(typeof this.internal_config.eduzz !== 'undefined' && this.internal_config.eduzz.enabled){
          return true;
        } else{
          return false;
        }

      },

      background() {
        let bg = this.internal_config.backgroundColor;

        if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {

          bg += ' url("' + this.internal_config.backgroundImage + '")';
          bg += ' ' + this.internal_config.backgroundPosition;
          bg += ' / ' + this.internal_config.backgroundSize;
          bg += ' ' + this.internal_config.backgroundRepeat;
          bg += ' ' + this.internal_config.backgroundOrigin;
          if (typeof this.internal_config.backgroundAttachment !== 'undefined') { bg += ' ' + this.internal_config.backgroundAttachment }
        }


        // hotmart background
        if(typeof this.internal_config.hotmart !== 'undefined' && this.internal_config.hotmart.enabled) {
         bg = this.internal_config.hotmart.background
        }

         // eduzz background
        if(typeof this.internal_config.eduzz !== 'undefined' && this.internal_config.eduzz.enabled) {
         bg = '#c7c7c7'
        }

        return bg;
      },
      border() {
        return this.internal_config.border;
      },
      width() {
        return this.internal_config.width;
      },
      height() {
        return this.internal_config.height;
      },
      minHeight() {
        return this.internal_config.minHeight;
      },
      animation() {
        return true;
      },
      onResize: function(x, y, width, height) {
        this.internal_config.width = width + 'px';
        this.internal_config.height = height + 'px';
      },

      focusElement(e) {
        this.$root.$emit('focusElement', this);
        this.$root.$emit('handlerElement', this);

        e.stopPropagation();
        e.preventDefault();
      },
      showResources() {
        // return this.$refs.resourcesData.getValuesData();
      },

      // change order on html
      changeOrderPanel(elem, idx) {
        let id = elem.$el.id;
        let sibling = idx === 1 ? document.getElementById(id).nextSibling : document.getElementById(id).previousSibling;

        if (sibling === null) {
          return true;
        }

        this.$root.$emit('changeOrderElementsInside', this.id, id, sibling.id, idx);
      },

      applyJarallax() {
        let vm = this;
        setTimeout(function() {
          if (vm.internal_config.parallaxActive === true) {
            $(vm.$refs.boxElem).jarallax({
              type: vm.internal_config.parallaxEffect,
              speed: vm.internal_config.parallaxSpeed / 10,
              imgSize: vm.internal_config.backgroundSize,
              imgPosition: vm.internal_config.backgroundPosition,
              imgRepeat: vm.internal_config.backgroundRepeat
            });
          }
        }, 1000);
      },

      handler: function(e) {
        // this.$el.classList.add('animated', 'jello', 'infinite');
        this.$root.$emit('focusElement', this);
        this.$root.$emit('handlerElement', this, true);
        e.stopPropagation();
        e.preventDefault();
      },
      style() {
        let style = `left:  ${this.internal_config.left};
                     padding-top: ${this.internal_config.paddingTop};
                     padding-left: ${this.internal_config.paddingLeft};
                     z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                     padding-right: ${this.internal_config.paddingRight};
                     padding-bottom: ${this.internal_config.paddingBottom};
                     top: ${this.internal_config.top}`;
        return style;
      },

      setCallbackChangeDevice(values) {
        this.$emit('setCallbackChangeDevice', values);
      },

      PinElement: function() {
        this.$root.$emit('PinElement', this);
      },

      build(config) {
        let vm = this;
        vm.internal_config = _.merge(vm.internal_config, config);
        vm.keyChange++;
        vm.$forceUpdate();

        vm.$eventHub.setValueElementConfig(vm.id, vm.internal_config);
      },
      sendNewChilds() {
        let vm = this;

        setTimeout(() => {
          vm.$eventPointer.changePointerState(true);
          vm.$eventPointer.logChilds(vm.id, vm.elements);
          setTimeout(() => {
            vm.$eventPointer.changePointerState(true);
          }, 500);
        }, 1000);
      }
    },
    mounted() {
      let device, childs, id, config;
      ({device, childs, id, config} = this.$props);

      this.device = device;
      this.build(config);

      if(typeof this.internal_config.hotmart === 'undefined') {
        this.internal_config.hotmart = {
          enabled: false,
          key: ''
        }
      }

      if (typeof childs === 'undefined') {
        childs = [];
        this.internal_config.childs = [];
      }

      if (typeof id !== 'undefined') {
        this.id = id;
      }

      let objIds = [];
      $('[id]').each(function() {
        var ids = $('[id="' + this.id + '"]');
        if (ids.length > 1 && ids[0] === this && parseInt(this.id)) { objIds.push(this.id) }
      });

      if (objIds.includes(this.id)) {
        let newId = Date.now() + parseInt(Math.random() * 10000);
        this.id = newId;

        childs.forEach((el, index) => {
          try {
            childs[index].config.parent_id = newId;
          } catch (e) {
          }
        });

        this.$refs.elem.id = newId;
      }

      this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));

      let internalConfig = window.mergeRecursive(this.props, this.$props.config);
      this.internal_config = {...internalConfig, ...this.internal_config};

      if (this.$props.preview) {
        // this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');

        this.applyJarallax();
      }

      this.$root.$on('setConfigElement', (id, obj) => {
        if (+this.id === +id) {
          this.config = obj;
          this.internal_config = obj;
        }
      });
      this.$root.$on('setChildsObj', (id) => {
        if (parseInt(this.id) === parseInt(id)) {
          this.$eventPointer.logChilds(this.id, this.elements);

          let childsHub = this.$eventHub.getChilds(this.id);

          this.config.childs = childsHub;
          this.internal_config.childs = childsHub;

          this.elements = {};
          this.$nextTick(() => {
            this.elements = childsHub.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
            this.componentKey += 1;

            this.$nextTick(() => {
              this.sendNewChilds();
              this.$root.$emit('activeSort');
            });
          });
        }
      });

      this.$root.$on('setChildsUndoRedo', (id, childs) => {
        if (+this.id === +id) {
          this.$eventHub.setChilds(this.id, childs);

          this.config.childs = childs;
          this.internal_config.childs = childs;

          this.elements = {};
          this.$nextTick(() => {
            this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
            this.componentKey += 1;
          });
        }
      });
    },
    updated() {
      // Chama e Seta os dados de pin no preview
      if (this.internal_config.pinConfig.pin) {
        this.$root.$emit('applyPin', this);
      }
      if (this.$props.preview) {
        this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');
      }
    }
  };

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  [element="BoxComponent"] .vdr {
    min-height: 10px !important;
  }

  @media (max-width: 800px) {
    .sitebuilder-element-receiver {
      max-width: 220px;
      min-height: 10px;
    }
  }

  .hotmart-preview > p,
  .hotmart-preview > img {
    color: white !important;
    display: flex;
    vertical-align: middle;
    align-items: center
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Box/Box.vue